export default "__VITE_ASSET__BUR3$T9I__"